import { createStore } from "vuex";

const store = createStore({
    state() {
        return {
            totalItemsInCart: 0,
            cart: [],
            selectedItem: Object,
            allProducts: Array,
            isAllProductsLoading: true,
            apparelProducts: Array,
            isApparelProductsLoading: true,
            electronicsProducts: Array,
            isElectronicsProductsLoading: true
        }
    },
    mutations: {
        increment(state) {
            state.totalItemsInCart++;
        },
        decrement(state) {
            state.totalItemsInCart--;
        },
        selectedItem(state, payload) {
            console.log("selected item called" + JSON.stringify(payload))

            state.selectedItem = payload
        },
        addToCart(state, payload) {
            state.cart.push(payload)
        },
        removeFromCart(state, payload) {
            let indexToRemove = state.cart.indexOf(payload)
            state.cart.splice(indexToRemove, 1)
        },
        getAllProducts(state) {
            state.isAllProductsLoading = true
            console.log("hello from state getAllProducts")
            fetch('https://fakestoreapi.com/products')
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    state.allProducts = data
                    return data
                }).finally(() => {
                    state.isAllProductsLoading = false
                });
        },
        getApparel(state) {
            state.isAllProductsLoading = true
            console.log("hello from state getAllProducts")
            fetch('https://fakestoreapi.com/products')
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    state.apparelProducts = data.filter(data => data.category.includes("clothing"));
                    return data
                }).finally(() => {
                    state.isApparelProductsLoading = false
                });
        },
        getElectronics(state) {
            state.isAllProductsLoading = true
            console.log("hello from state getAllProducts")
            fetch('https://fakestoreapi.com/products')
                .then(response => response.json())
                .then(data => {
                    console.log(data)
                    state.electronicsProducts = data.filter(data => data.category.includes("electronics"));
                    return data
                }).finally(() => {
                    state.isElectronicsProductsLoading = false
                });
        }
    },
    actions: {
        increment({ commit }) {
            commit('increment')
        },
        decrement({ commit }) {
            commit('decrement')
        },
        selectedItem({ commit }, item) {
            commit('selectedItem', item)
        },
        addToCart({ commit }, item) {
            commit('addToCart', item)
        },
        removeFromCart({ commit }, item) {
            commit('removeFromCart', item)
        },
        getAllProducts({ commit }) {
            commit('getAllProducts')
        },
        getApparel({commit}){
            commit('getApparel')
        },
        getElectronics({commit}){
            commit('getElectronics')
        }
    },
    getters: {
        getSelectedItem(state) {
            return state.selectedItem
        }
    }
})
export default store;